import React from "react";
import PropTypes from "prop-types";
import Header from "../header";
import Footer from "../footer";
import { graphql, Script, useStaticQuery } from "gatsby";
// This ensures that the icon CSS is loaded immediately before attempting to render icons
import "@fortawesome/fontawesome-svg-core/styles.css";
import { config } from "@fortawesome/fontawesome-svg-core";
// Prevent fontawesome from dynamically adding its css since we did it manually above
config.autoAddCss = false;

export default function LayoutBase(props) {
  const data = useStaticQuery(graphql`
    query LayoutBase {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  return (
    <>
      {/* <!-- Start of HubSpot Embed Code -->  */}
      <Script
        type="text/javascript"
        id="hs-script-loader"
        async
        strategy="idle"
        src="//js.hs-scripts.com/19562737.js"
      />
      {/* <!-- End of HubSpot Embed Code --> */}
      <Header siteTitle={data.site.siteMetadata.title} location={props.location} />
      {props.children}
      <Footer />
    </>
  );
}

LayoutBase.propTypes = {
  children: PropTypes.node.isRequired,
};
